export enum PermissionTemplate {
    NONE = "NONE",
    VIEW = "View",
    EDIT = "Edit",
    OWNER = "Owner",
    CUSTOM = "Custom"
}
